import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { translations } from '@/lib/translations';
type Language = 'vi' | 'en';
interface I18nState {
  lang: Language;
  setLang: (lang: Language) => void;
}
const useI18nStore = create<I18nState>()(
  persist(
    (set) => ({
      lang: (typeof window !== 'undefined' && (window.navigator.language.startsWith('vi') ? 'vi' : 'en')) as Language || 'vi',
      setLang: (lang) => set({ lang }),
    }),
    {
      name: 'prompt-nexus-lang',
    }
  )
);
export function useI18n() {
  const lang = useI18nStore((s) => s.lang);
  const setLang = useI18nStore((s) => s.setLang);
  const t = (path: string): string => {
    const keys = path.split('.');
    let current: any = translations[lang];
    for (const key of keys) {
      if (current[key] === undefined) {
        // Fallback to English if key missing in VI
        let fallback: any = translations['en'];
        for (const fkey of keys) {
          if (fallback[fkey] === undefined) return path;
          fallback = fallback[fkey];
        }
        return fallback;
      }
      current = current[key];
    }
    return current as string;
  };
  return { lang, setLang, t };
}